import type { RouteRecordRaw } from "vue-router";
import Register from "./pages/Register.vue";
import FinishRegistration from "./pages/FinishRegistration.vue";
import ForgotPassword from "./pages/ForgotPassword.vue";
import ResetPassword from "./pages/ResetPassword.vue";

export const publicRoutes: RouteRecordRaw[] = [
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: { guestOnly: true, title: "Registro" },
  },
  {
      path: "/finish-registration",
      name: "verify-email",
      component: FinishRegistration,
      meta: { guestOnly: true, title: "Finalizar Registro" },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
    meta: { guestOnly: true, title: "Recuperar Contraseña" },
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: ResetPassword,
    meta: { guestOnly: true, title: "Restablecer Contraseña" },
  }
];
